<template>
  <v-card flat>
    <v-data-table :headers="headers" :items="items" hide-default-footer>
      <template v-slot:top>
        <v-card-title>
          <v-icon>mdi-email</v-icon>
          <span class="headline ml-3">Trade by Secret Email</span>
        </v-card-title>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.terminal="{ item }">{{ item.terminal.name }}</template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          v-if="!item.terminal.id"
          color="primary"
          small
          class="mr-2"
          icon
          :loading="item.id == itemLoading"
          @click="addToken(item)"
        >
          <v-icon small>add</v-icon>
        </v-btn>
        <v-btn
          v-else
          color="primary"
          small
          icon
          :loading="item.id + 'del' == itemLoading"
          @click="deleteToken(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { TERMINAL } from "@/store/actions.type";

// short ID
var shortid = require("shortid");

export default {
  name: "EmailTerminal",
  props: {
    accounts: {
      type: null,
      default: null
    },
    terminals: {
      type: null,
      default: null
    }
  },
  data() {
    return {
      items: [],
      token: null,
      itemLoading: null,
      overlay: false,
      headers: [
        {
          text: "Account",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "Token Email", value: "terminal" },
        { text: "Actions", value: "actions" }
      ]
    };
  },
  computed: {
    ...mapGetters(["errors", "currentUser"])
  },
  watch: {
    // currentUser(v) {
    //   console.log(v);
    //   if (!this.terminals) {
    //     this.$store
    //       .dispatch(TERMINAL.FETCH, v.id)
    //       .then(terminals => this.buildItems(this.accounts, terminals));
    //   } else {
    //     this.buildItems(this.accounts, this.terminals);
    //   }
    // }
  },
  mounted() {
    this.buildItems(this.accounts, this.terminals);
  },
  methods: {
    buildItems(accounts, terminals) {
      let items = [];
      accounts.forEach(element => {
        items.push({
          name: element.name,
          id: element.id,
          terminal:
            terminals.find(terminal => {
              return (
                terminal.accountId === element.id && terminal.type === "email"
              );
            }) || {}
        });
      });
      this.items = items;
      return items;
    },
    addToken(item) {
      this.itemLoading = item.id;
      let token = shortid.generate();
      let terminal = {
        id: "email." + token,
        type: "email",
        name: "".concat(token, process.env.VUE_APP_TERMINAL_EMAIL),
        accountId: item.id,
        userId: this.currentUser.uid
      };
      this.$store.dispatch(TERMINAL.CREATE, terminal).then(() => {
        this.$store.dispatch(TERMINAL.FETCH, this.currentUser.id).then(() => {
          this.itemLoading = null;
        });
      });
    },
    deleteToken(item) {
      this.itemLoading = item.id + "del";
      this.$store.dispatch(TERMINAL.DEL, item.terminal).then(() => {
        this.$store.dispatch(TERMINAL.FETCH, this.currentUser.id).then(() => {
          this.itemLoading = null;
        });
      });
    }
  }
};
</script>

<style></style>
